import * as React from 'react';
// import TableHead from '@mui/material/TableHead';
import { Box, Unstable_Grid2 as Grid, Typography } from '@mui/material';
import TextFieldBase from "../../components/text/TextFieldBase";
import LoadingButtonBase from "../../components/button/LoadingButtonBase";

import ButtonLayout from "../../components/layout/buttonlayout";
import BottomLayout from "../../components/layout/searchlayout/BottomLayout";
import TopLayout from "../../components/layout/searchlayout/TopLayout";

import ComboCode from "../../components/combo/ComboCode";
import { useState, useRef, useCallback, useEffect,useMemo } from "react";
import AxiosLoading from "../../components/axios/AxiosLoading";
// import DateCalender from "../../components/date/DateCalender";
// import RadioGroup from "../../components/radioGroup/RadioGroup";
import ElectronicPaymentP from "./ElectronicPaymentP";
import { funcMenuWriteYn} from "../../utils/CommonFunction";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";

import "../common/css/Table.css";
import AxiosCommon from "../../components/axios/AxiosCommon";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import DateCalender from "../../components/date/DateCalender";

import { dateFormatter, colSpan, valueGetter , truncateText} from "../../components/grid/CommonGrid";
import { isMobile } from 'react-device-detect';
import { useNavigate } from "react-router-dom";

import { IconFile,} from "@tabler/icons";
import {BORDER_RIGHT, GRID_FONT_SIZE} from "../common/StyleConstants.js"
import GridPanel from '../../components/grid/GridPanel.js';


// 커스텀 셀 렌더러 컴포넌트
const CustomCellRenderer = (params) => {
  const approvalColor = params.data.approval1_nm === '승인' ? 'blue' : 
                        params.data.approval1_nm === '검토' ? 'red' : 
                        params.data.approval1_nm === '반려' ? 'red' : 'black';
  
  const lineStyle = {
    margin: 0,
    padding: 0,
    lineHeight: '1.3',
    // fontSize: '12px' // 필요한 경우 글꼴 크기를 줄일 수 있습니다.
  };
  
  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      <div style={{...lineStyle,  color: 'black' }}>
        {params.data.approvaluser1_nm} <span style={{ color: approvalColor }}>{params.data.approval1_nm?`[${params.data.approval1_nm}]`:''}</span>
      </div>      
      <div style={{...lineStyle,  color: 'black' }}>
        {params.data.approval1_dm}
      </div>
    </div>
  );
};

const CustomCellRenderer2 = (params) => {
  const approvalColor = params.data.approval2_nm === '승인' ? 'blue' : 
                        params.data.approval2_nm === '검토' ? 'red' : 
                        params.data.approval2_nm === '반려' ? 'red' : 'black';
  
  const lineStyle = {
    margin: 0,
    padding: 0,
    lineHeight: '1.3',
    // fontSize: '12px' // 필요한 경우 글꼴 크기를 줄일 수 있습니다.
  };

  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      <div style={{...lineStyle,  color: 'black' }}>
        {params.data.approvaluser2_nm} <span style={{ color: approvalColor }}>{params.data.approval2_nm?`[${params.data.approval2_nm}]`:''}</span>
      </div>      
      <div style={{...lineStyle,  color: 'black' }}>
        {params.data.approval2_dm}
      </div>
    </div>
  );
};

const CustomCellRenderer3 = (params) => {
  const approvalColor = params.data.approval3_nm === '승인' ? 'blue' : 
                        params.data.approval3_nm === '검토' ? 'red' : 
                        params.data.approval3_nm === '반려' ? 'red' : 'black';
  
  const lineStyle = {
    margin: 0,
    padding: 0,
    lineHeight: '1.3',
    // fontSize: '12px' // 필요한 경우 글꼴 크기를 줄일 수 있습니다.
  };

  return (
    <div style={{ whiteSpace: 'pre-wrap' }}>
      <div style={{...lineStyle,  color: 'black' }}>
        {params.data.approvaluser3_nm} <span style={{ color: approvalColor }}>{params.data.approval3_nm?`[${params.data.approval3_nm}]`:''}</span>
      </div>      
      <div style={{...lineStyle,  color: 'black' }}>
        {params.data.approval3_dm}
      </div>
    </div>
  );
};

// 커스텀 셀 렌더러 컴포넌트 (이미지 또는 아이콘 추가)
const ImageCellRenderer = (params) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {params.data.image_cd === '' || params.data.image_cd === null ? '' : <IconFile style={{ color: "#5383d7" }} />}
      {/*##0716f6" */} 
    </div>    
  );
};

const ElectronicPaymentS = (props) => {
  const reduxProfile = useSelector((state) => state.Profile.data);
  // const reduxCodeInfo = useSelector((state) => state.CodeInfo?.data);
  const reduxMenuWriteYn = funcMenuWriteYn(useSelector((state) => state.MenuInfo.data),"ElectronicPaymentS");   
  const axiosCommon = AxiosCommon();
  const gridRef = useRef();
  
  const [whereValue, setWhereValue] = useState({
    company_cd: reduxProfile?.company_cd,
    shop_cd: reduxProfile?.shop_cd,
    user_cd: reduxProfile?.user_cd,
    // from_dt: dayjs(new Date`()).add(-31, "day").format("YYYYMMDD"),
    // to_dt: dayjs().format("Y`YYYMMDD"),    
    from_dt : dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format("YYYYMMDD"),   //매월 1일
    to_dt : dayjs(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format("YYYYMMDD"), //매월 말일
    title_ds:'',
    make_cd:'',
    electronic_cd: '',
    dealDate_tp: '',    
  });  

  const [validation, setValidation] = useState({});

  // const [rowManager] = useState(comboOption.concat(reduxCodeInfo.filter(params => params.codetype_cd === 'tb_user').map(
  //       params => { return { value: params.code_cd, label: params.code_nm } }
  //   ))
  // );
  
  const [totalCount, setTotalCount] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openElectronicPaymentP, setOpenElectronicPaymentP] = useState({
    open: false,
    electronic_cd: '',
    electronic_dt: '',
    make_cd: '',
    approval1_cd: '', //1차승인자코드
    approval2_cd: '', //1차승인자코드
    approval3_cd: '', //1차승인자코드
  });

  const [count, setCount] = useState({
    all: 0,
    ask: 0,
    goOver: 0,
    refer: 0,
    approval: 0,
  })
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  const [columnDefs] = useState([   
    // {          
    //   field: "check",
    //   headerName: "",
    //   minWidth: 50,
    //   maxWidth: 50,
    //   headerCheckboxSelection: true,
    //   checkboxSelection: true,
    //   editable: false,
    // },
    {
      headerName: "순번",
      field: "seq",
      maxWidth: 50,
      valueGetter: (params) => {
        return valueGetter(params.data.seq, "total", params.node.rowIndex + 1);
      },
      colSpan: (params) => {
        return colSpan(params.data.seq, "total", 3);
      },
      headerClass:"ag-header-font-desktop",
      cellStyle: { justifyContent: "center", textAlign: "center" , alignItems:"center",
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },
    },    
    { headerName: "전자결재코드",   field: "electronic_cd", hide: true, maxWidth: 150, },
    { headerName: "구분",   field: "electronic_tp", hide: true, maxWidth: 150, },
    { headerName: "구분",   field: "electronic_nm", hide: false, 
      maxWidth: 180, 
      cellRenderer:truncateText,
      headerClass:"ag-header-font-desktop",
      cellStyle: { 
        whiteSpace: 'pre-wrap', 
        justifyContent: "center", 
        textAlign: "center"   ,
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },        
    },
    { headerName: "제목",   field: "title_ds", hide: false, 
      maxWidth: 280, 
      cellRenderer:truncateText,
      headerClass:"ag-header-font-desktop", 
      cellStyle: { 
        whiteSpace: 'pre-wrap', 
        justifyContent: "center", 
        textAlign: "center"   ,
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },     
    },
    { headerName: "내용",   field: "electronic_ds", hide: false, 
      maxWidth: 450, 
      headerClass:"ag-header-font-desktop",
      cellStyle: { 
        whiteSpace: 'pre-wrap', 
        justifyContent: "left", 
        textAlign: "center"   ,
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },
      cellRenderer:truncateText,
    },  
    { headerName: "파일",   field: "image_cd", hide: false, 
      maxWidth: 100, 
      headerClass:"ag-header-font-desktop",
      cellStyle: { 
        whiteSpace: 'pre-wrap', 
        justifyContent: "center", 
        textAlign: "center"   ,
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },
      cellRenderer: ImageCellRenderer,      
    },    
    { headerName: "파일",   field: "url_ds", hide: true, maxWidth: 60, },
    { headerName: "기안자",   field: "make_cd", hide: true, maxWidth: 80, 
      headerClass:"ag-header-font-desktop",      
    },   
    { headerName: "기안자",   field: "make_ds", hide: false,   maxWidth: 100, 
      headerClass:"ag-header-font-desktop",
      cellStyle:{ justifyContent: "center", textAlign: "center" ,
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },
    }, 
    { headerName: "1차승인자코드",   field: "approval1_cd", hide: true, maxWidth: 150, },   
    { headerName: "2차승인자코드",   field: "approval2_cd", hide: true, maxWidth: 150, },   
    { headerName: "3차승인자코드",   field: "approval3_cd", hide: true, maxWidth: 150, },   
    { headerName: "기안일자"  ,   field: "electronic_dt",  hide: false, maxWidth: 150, 
      headerClass:"ag-header-font-desktop",
      cellStyle: { justifyContent: "center", textAlign: "center" ,
        borderRight: BORDER_RIGHT,   
        fontSize:GRID_FONT_SIZE, 
      },
      cellRenderer: dateFormatter,
    }, 
    { headerName: " 1차\n결재",
      minWidth: 160, maxWidth: 180,  
      field: "approvaluser1_nm", 
      cellRenderer: CustomCellRenderer,
      headerClass:"ag-header-font-desktop",
      cellStyle: { whiteSpace: 'pre-wrap', justifyContent: "center", textAlign: "center"  ,
        borderRight: BORDER_RIGHT,   
        // fontSize:GRID_FONT_SIZE, 
      },
      autoHeight: true,
    },         
    { headerName: " 2차\n결재",
      minWidth: 160, maxWidth: 180,  
      field: "approvaluser2_nm", 
      cellRenderer: CustomCellRenderer2,
      headerClass:"ag-header-font-desktop",
      cellStyle: { whiteSpace: 'pre-wrap', justifyContent: "center", textAlign: "center"   ,
        borderRight: BORDER_RIGHT,   
        // fontSize:GRID_FONT_SIZE, 
      },
      autoHeight: true,
    },   
    { headerName: " 3차\n결재",
      minWidth: 160, maxWidth: 180,  
      field: "approvaluser3_nm", 
      cellRenderer: CustomCellRenderer3,
      headerClass:"ag-header-font-desktop",
      cellStyle: { whiteSpace: 'pre-wrap', justifyContent: "center", textAlign: "center"  ,
        borderRight: BORDER_RIGHT,   
        // fontSize:GRID_FONT_SIZE, 
      },
      autoHeight: true,
    },    
  ]);
  // eslint-disable-next-line
  const [rowData, setRowData] = useState([]);
  const [rowDataAsk, setRowDataAsk] = useState([]);
  const [rowDataGover, setRowDataGoOver] = useState([]);
  const [rowDataRefer, setRowDataRefer] = useState([]);
  const [rowDataApproval, setRowDataApproval] = useState([]);

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        // style={{height:'calc(var(--vh, 1vh) * 70)'}}
        style={{ height: "94%" }}
        {...other}
      >
        {value === index && (
          <Box
            id="tabChildren"
            sx={{
              p: 1,
              width: "100%",
              height: "100%",
            }}
          >
            {children}
          </Box>
        )}
      </div>
    );
  };

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const a11yProps = (index) => {
    return {
      id: `basic-tab-${index}`,
      "aria-controls": `basic-tabpanel-${index}`,
    };
  };

  const onChange = (e) => {
    //일자,텍스트필드,브랜드 오류초기화
    const { value, name, valueNm } = e.target;
    if (name === "customer_cd") {
      setValidation({ ...validation, [name]: "" });
      setWhereValue({ ...whereValue, [name]: valueNm });
    } else {
      setValidation({ ...validation, [name]: "" });
      setWhereValue({ ...whereValue, [name]: value })
    };
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log("newValue",newValue);
  };

  const funcExcel = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const validationFunc = () => {
    //필수값 체크시 useState값은 비동기로 처리되어 오류를 배열로 만든 후 한번에 넣어야됨
    let validateValue = {};

    // if (!whereValue["electronic_tp"]) {
    //   validateValue = {
    //     ...validateValue,
    //     electronic_tp: "기안구분을 입력하세요.",
    //   };
    // }  
    
    //일자체크
    if (
      whereValue["from_dt"] === "" ||
      whereValue["from_dt"] === "Invalid Date"
    ) {
      validateValue = {
        ...validateValue,
        from_dt: "일자형식이 잘못되었습니다.",
      };
    }
    if (
      whereValue["to_dt"] === "" ||
      whereValue["to_dt"] === "Invalid Date"
    ) {
      validateValue = {
        ...validateValue,
        to_dt: "일자형식이 잘못되었습니다.",
      };
    }

    if (Object.keys(validateValue).length === 0) {
      return true;
    } else {
      setValidation(validateValue);
      return false;
    }
  };


  const funcSearch = async () => {
    if (!validationFunc()) return;
    //초기화
    setRowData([]);
    setCount({    
      all: 0,
      ask: 0,
      goOver: 0,
      refer: 0,
      approval: 0,
    });

    let paramRepo = {
      params: {
        company_cd: whereValue["company_cd"],
        title_ds: whereValue["title_ds"],
        make_cd: whereValue["make_cd"],
        electronic_tp: whereValue["electronic_tp"],
        electronic_cd: whereValue["electronic_cd"],
        approval_tp: whereValue["approval_tp"],
        dealDate_tp:whereValue["dealDate_tp"],
        from_dt: whereValue["from_dt"],
        to_dt: whereValue["to_dt"],
      },
    };

    if (loading) return;
    setLoading(true);
    try {
      await axiosCommon
        .get("/community/electronics/select", paramRepo)
        .then((response) => {
          if (response.data?.code === 200) {
            setRowData(response.data.data);
            setRowDataAsk(response.data.data.filter((params) => params.approval3_nm === null));
            setRowDataGoOver(response.data.data.filter((params) => params.approval3_nm === "검토"));
            setRowDataRefer(response.data.data.filter((params) => params.approval3_nm === "반려"));
            setRowDataApproval(response.data.data.filter((params) => params.approval3_nm === "승인"));
            
            setCount({ ...count, 
              all: response.data.data.length, 
              ask: response.data.data.filter((params) => params.approval3_nm === null).length, 
              goOver: response.data.data.filter((params) => params.approval3_nm === "검토").length,  
              refer: response.data.data.filter((params) => params.approval3_nm === "반려").length,  
              approval: response.data.data.filter((params) => params.approval3_nm === "승인").length,  
            });
            setTotalCount(response.data.data.length);
          }
        });
    } catch (error) {
      window.alert(error);
    } finally {
      setLoading(false);
    }
  };
  
  const funcElectronicPaymentP = async () => {
    setOpenElectronicPaymentP({
      open: true,
      electronic_cd: '',
      electronic_dt: '',
      approval1_cd: '',
      approval2_cd: '',
      approval3_cd: '',
    });
  };

  // //그리드 더블클릭 이벤트
  // const onCellDoubleClicked = (e) => {  
  //   if (
  //     e.data.make_cd === whereValue["user_cd"] || 
  //     e.data.approval1_cd === whereValue["user_cd"] || 
  //     e.data.approval2_cd === whereValue["user_cd"] || 
  //     e.data.approval3_cd === whereValue["user_cd"] 
  //   ){
  //     if (e.column.colId ==="image_cd" && e.data.image_cd !== ''){
  //       window.open(e.data.url_ds, '_blank');
  //     }else{
  //       setOpenElectronicPaymentP({
  //         open: true,
  //         electronic_cd: e.data.electronic_cd,
  //         electronic_dt: e.data.electronic_dt,
  //         approval1_cd: e.data.approval1_cd, //1차승인자코드
  //         approval2_cd: e.data.approval2_cd, //1차승인자코드
  //         approval3_cd: e.data.approval3_cd, //1차승인자코드
  //       });
  //     }
  //     return;
  //   }else{
  //     alert("세부내용을 확인 할 수 없습니다.\n(기안자,결재자만 확인 가능합니다.)");
  //     return;
  //   } 
  // }

  const funcElectronicPaymentClose = (item) => {
    setOpenElectronicPaymentP({
      open: false,
      electronic_cd: '',
      electronic_dt: '',
      approval1_cd: '',
      approval2_cd: '',
      approval3_cd: '',
    });
    if(item === 'save'){
      funcSearch();
    }
  }

  const userCd = whereValue.user_cd;
  // **메모이제이션된 더블클릭 핸들러**
  const onCellDoubleClicked = useCallback((e) => {
    if (
      e.data.make_cd === userCd || 
      e.data.approval1_cd === userCd || 
      e.data.approval2_cd === userCd || 
      e.data.approval3_cd === userCd 
    ){
      if (e.column.colId ==="image_cd" && e.data.image_cd !== ''){
        window.open(e.data.url_ds, '_blank');
      }else{
        setOpenElectronicPaymentP({
          open: true,
          electronic_cd: e.data.electronic_cd,
          electronic_dt: e.data.electronic_dt,
          approval1_cd: e.data.approval1_cd, //1차승인자코드
          approval2_cd: e.data.approval2_cd, //1차승인자코드
          approval3_cd: e.data.approval3_cd, //1차승인자코드
        });
      }
      return;
    }else{
      alert("세부내용을 확인 할 수 없습니다.\n(기안자,결재자만 확인 가능합니다.)");
      return;
    } 
  }, [userCd]);  

  // 탭 패널 + 그리드 매핑을 useMemo로 묶음
  const panels = useMemo(() => [rowData, rowDataAsk, rowDataGover,rowDataRefer, rowDataApproval].map((data, idx) => (
    <TabPanel key={idx} value={value} index={idx}>
      <GridPanel
        ref={gridRef}
        rowData={data}
        columnDefs={columnDefs}
        rowSelection={'multiple'}
        onCellDoubleClicked={onCellDoubleClicked} 
        gridTheme={props.gridtheme}
      />
    </TabPanel>
  )), [rowData,rowDataAsk, rowDataGover, rowDataRefer, rowDataApproval, value, columnDefs, onCellDoubleClicked, props.gridtheme]);
  
  
  //팝업창으로 뜰때 종료 버튼 숨김.
  const [visible, setVisible] = useState({    
    buttonClose:false,
  })  
  
  useEffect(() => {
    if(isMobile){
      navigate("/rentmain/rent/Rent02RMobile");
    }
    else{
      if (props.electronic_cd===true){
        //Dash board private에서 props전달 할 때는 고객번호가 없음.
        setValue(props.tabValue);
        setVisible({...visible,  buttonClose: true,});
      }else{
        setValue(0);
        setVisible({...visible,  buttonClose: false,});
      }
      funcSearch();
    }
    // eslint-disable-next-line
  }, []);


  return (
    <>
      {loading && <AxiosLoading />}
      <ButtonLayout
        MenuName ='전자결재'
      >
        <LoadingButtonBase
          label="조회"
          name="BUTTON_SEARCH"
          onClick={funcSearch}
        // loading={loading}
        />
        {reduxMenuWriteYn && 
        <LoadingButtonBase
          label="신규"
          name="BUTTON_SEARCH"
          onClick={funcElectronicPaymentP}
        />}
        <LoadingButtonBase
          autoFocus
          label="엑셀"
          onClick={funcExcel}
          // loading={loading}
          variant="contained"
          name="BUTTON_EXCEL"
        />
        {visible["buttonClose"] &&
        <LoadingButtonBase
          label="종료"
          onClick={props.onClick}
          variant="contained"
          name="BUTTON_CLOSE"
        />}
      </ButtonLayout>

      <TopLayout mt='0px'>
        <TextFieldBase
          required={false}
          label="제목/내용"
          placeholder="제목/내용"
          name={"title_ds"} //바인딩변수'
          value={whereValue["title_ds"]}
          validation={validation["title_ds"]} //값 체크후 오류시 해당 오류메세지 등록
          onChange={onChange}
          onKeyPressEnter={funcSearch}
          autoFocus={true}
          width="230px"
        />     
        < ComboCode
          required={false}
          multiple={false}
          placeholder="기안구분"
          comboText="기안구분"
          codetype="C51"
          codeName="선택"
          name={"electronic_tp"} //바인딩변수
          onChange={onChange} //바인딩 변수 변경 func
          value={whereValue["electronic_tp"]} //화면의표시값
          validation={validation["electronic_tp"]} //
        />   
        <ComboCode
          required={false}
          multiple={false}
          placeholder="기안자"
          comboText="기안자"
          codetype="tb_user"
          name={"make_cd"} //
          onChange={onChange} //
          value={whereValue["make_cd"]} //
        // validation={validation["make_cd"]} //
          width="130px"
        /> 
        {/* < ComboCode
          required={false}
          multiple={false}
          placeholder="기안상태"
          comboText="기안상태"
          codetype="C52"
          codeName="선택"
          name={"approval_tp"} //바인딩변수
          onChange={onChange} //바인딩 변수 변경 func
          value={whereValue["approval_tp"]} //화면의표시값
          validation={validation["approval_tp"]} //
          width="130px"
        />               */}
        <ComboCode
          multiple={false} //false : 단일선택 , true : 멀티선택
          comboText="일자구분"
          codetype="C93"
          name={"dealDate_tp"} //
          onChange={onChange} //
          value={whereValue["dealDate_tp"]} //
          width="110px"
        /> 
        <DateCalender
          required={false} //필수사항 default : flase
          label="일자 From" //label text
          name={"from_dt"} //바인딩변수
          onChange={onChange} //바인딩 변수 변경 func
          value={whereValue["from_dt"]} //화면의표시값          
          // validation={validation["businessFrom_dt"]} //값 체크후 오류시 해당 오류메세지 등록
          width={isMobile?"130px":"140px"}      //컨퍼넌트넓이 default : 222.67
        />
        <DateCalender
          required={false} //필수사항 default : flase
          label="일자 To" //label text
          name={"to_dt"} //바인딩변수
          onChange={onChange} //바인딩 변수 변경 func
          value={whereValue["to_dt"]} //화면의표시값
          // validation={validation["businessFTo_dt"]} //값 체크후 오류시 해당 오류메세지 등록
          width={isMobile?"130px":"140px"}      //컨퍼넌트넓이 default : 222.67
        />        
      </TopLayout>

      <Box sx={{ width: "98%", pl: '10px', pr: '10px', pt: '0px', pb: '0px' }}>
        <Grid container spacing={2} alignItems="right" justifyContent="center">
          <Grid lg={6} md={6} sm={6} xs={12}>
            <Grid
              xs={12}
              container
              alignItems="center"
              justifyContent="flex-start"
            >
              
            </Grid>
          </Grid>
          <Grid lg={6} md={6} sm={6} xs={12}>
            <Grid
              xs={12}
              container
              alignItems="center"
              justifyContent="flex-end"
            >
              <Typography sx={{ textAlign: 'left',}} component="div" >
                <font color="red"> <span id="selectedRent"></span> {totalCount} </font>개의 결재 업무가 검색되었습니다.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <BottomLayout>
        <Box sx={{ height: "100%", width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            {/* <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              // centered
              scrollButtons
              selectionFollowsFocus
              sx={{ height: "42px", }}
            >
              <Tab
                iconPosition="start"
                label={`전체 ${count["all"]}`}
                title='all'
                {...a11yProps(0)}
              />
              <Tab
                iconPosition="start"
                label={`신청 ${count["ask"]}`}
                {...a11yProps(1)}
              />
              <Tab
                iconPosition="start"
                label={`검토 ${count["goOver"]}`}
                {...a11yProps(2)}
              />
              <Tab
                iconPosition="start"
                label={`반려 ${count["refer"]}`}
                {...a11yProps(3)}
              />
              <Tab
                iconPosition="start"
                label={`승인 ${count["approval"]}`}
                {...a11yProps(4)}
              />
            </Tabs> */}

            <Tabs value={value} onChange={handleChange} sx={{ height: '42px' }}>              
              <Tab label={`전체 ${count["all"]}`} {...a11yProps(0)} />
              <Tab label={`신청 ${count["ask"]}`} {...a11yProps(1)} />
              <Tab label={`검토 ${count["goOver"]}`} {...a11yProps(2)} />
              <Tab label={`반려 ${count["refer"]}`} {...a11yProps(3)} />
              <Tab label={`승인 ${count["approval"]}`} {...a11yProps(4)} />
            </Tabs>
          </Box>
          
          {panels}

        </Box>

      </BottomLayout>


      <Dialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              // height:"100%",
              maxWidth: "1150px",  // Set your width here
            },
          }
        }}
        open={openElectronicPaymentP["open"]}
      >
        <DialogTitle />
        <ElectronicPaymentP
          gridtheme={props.gridtheme}
          onClick={funcElectronicPaymentClose}
          electronic_cd={openElectronicPaymentP["electronic_cd"]}
          electronic_dt={openElectronicPaymentP["electronic_dt"]}
        />
      </Dialog>

    </>
  );
}

export default React.memo(ElectronicPaymentS);
